import React, { Component } from 'react';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { MessageBars } from '../Outils/MessageBars';

import { TimelineVerticale } from '../Timeline/TimelineVerticale';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';
import { DataContact } from '../../data/DataContact';

/****************************************************************
 PROPS:
    idContact
    onAffichePanelContactHistorique
    onFermeFicheContactHistorique : méthode
    classnameinner : classe CSS (string)
    className : classe CSS (string)
****************************************************************/

var objetState = {
    idContact: null,
    listHistorique: [],

    titrePanelContactHistorique: 'Fiche contact historique',

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: '',
};

export class FicheContactHistorique extends Component {
    _creationContent() {
        return (this.state.listHistorique.length > 0 ? <TimelineVerticale listeActions={this.state.listHistorique} /> : <span>Aucune information disponible.</span>);
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _onInit() {
        this.setState(objetState);
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onFermeFicheContactHistorique();
    }

    _chargementDonnees() {

        let propsIdContactRenseignee = Immocom.getSiPropsRenseignee(this.props.idContact);
        let propsIdContactDifferentDeStateIdContact = (this.props.idContact !== this.state.idContact);

        if (propsIdContactRenseignee && propsIdContactDifferentDeStateIdContact) {
            this.setState({ enCoursDeTraitement: true, messageEnCoursTraitement: "Chargement de l'historique du contact" });

            let _chargementFicheContactHistorique = DataContact._chargementFicheContactHistorique(this.props.idContact);

            _chargementFicheContactHistorique
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let objetData = responseFetch.reponseAPIobjet;
                        let contact = objetData[0];
                        let historique = objetData[1];

                        let stateTemp = {};
                        stateTemp.idContact = this.props.idContact;
                        stateTemp.listHistorique = historique;
                        stateTemp.titrePanelContactHistorique = 'Fiche contact historique - ' + contact.civilite + ' ' + contact.nom + ' ' + contact.prenom;

                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                    }
                    else {
                        let stateTemp = {};
                        stateTemp.idContact = this.props.idContact;
                        stateTemp.listHistorique = [];
                        stateTemp.titrePanelContactHistorique = 'Fiche contact historique';

                        Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                    }
                });
        }
        
    }

    _onRenderFooterContent = () => {
        return (
            <div>
                <DefaultButton onClick={() => this._onAnnulation()}>Fermer</DefaultButton>
            </div>
        );
    };

    componentDidMount() {
        this._chargementDonnees();
    }

    componentDidUpdate() {
        if (!this.state.enCoursDeTraitement)
            this._chargementDonnees();
    }

    componentWillUnmount() {
    }

    render() {
        let content = this._creationContent();

        return (<div>
            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            {content}
        </div>);
    }
}